<script setup lang="ts">
import type { DistributionGroup } from '@forgd/contract/types'
import type { ValueFormat } from '@forgd/formatter'
import { formatValue } from '@forgd/formatter'
import { Stat, StatContent, StatGroup, StatHeader, StatLabel, StatValue } from '@forgd/ui-kit/stat'

interface SummaryStat {
  title: string
  value: number
  format?: ValueFormat
}

const props = defineProps<{ groups: Array<Partial<DistributionGroup>> }>()

const stats = computed<SummaryStat[]>(() => {
  const groups = props.groups
  return [
    {
      title: 'Total Allocation',
      value: groups.reduce((acc, group) => acc + (group.allocationPercentage || 0), 0),
      format: 'percent:2',
    },
    {
      title: 'Total Groups',
      value: groups.length,
    },
    {
      title: 'Internal',
      value: groups.filter(group => group.type === 'internal').length,
    },
    {
      title: 'External',
      value: groups.filter(group => group.type === 'external').length,
    },
  ]
})
</script>

<template>
  <StatGroup class="w-full justify-between bg-neutral-300">
    <Stat v-for="item in stats" :key="item.title">
      <StatHeader>
        <StatLabel>{{ item.title }}</StatLabel>
      </StatHeader>
      <StatContent>
        <StatValue size="lg" class="leading-6 tracking-normal!">
          {{ formatValue(item.value, item.format) }}
        </StatValue>
      </StatContent>
    </Stat>
  </StatGroup>
</template>
